/** Admin guide §2 — Sourcing Teams (`admin/SourcingTeamsTab.tsx`, Settings → Sourcing Teams). */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  Callout,
  HelpSectionCard,
  Li,
  P,
  SectionLink,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function AdminSourcingTeams(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-sourcing-teams')}>
      <Shot
        slug="admin-sourcing-teams"
        caption="Sourcing team cards, each with its member list and an Add sourcing team button."
      />
      <P>
        A sourcing team is a named group of sourcers with contact details — not a login account.
        Click <Btn>Add sourcing team</Btn> to create one.
      </P>

      <SubHead>The sourcing team dialog</SubHead>
      <Bullets>
        <Li>
          <Btn>Team Name</Btn> is required.
        </Li>
        <Li>
          A dynamic list of members — <Btn>Name</Btn> and <Btn>Email</Btn> per row. Use{' '}
          <Btn>+ Add member</Btn> for another row, or the × to remove one. A row is only kept if
          both its name and email are filled in.
        </Li>
      </Bullets>

      <Callout title="Delete here is a soft delete">
        <P>
          Deleting a sourcing team card marks it inactive rather than removing it outright — the
          opposite of the <SectionLink to="admin-teams">Teams</SectionLink> tab, where delete is
          permanent. There is no confirmation dialog either way.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
